import { createContext, useContext, useState } from 'react';

interface IFeatureFlagsService {
  featureFlags: FeatureNames;
  setFeatureFlags: (flags: FeatureNames) => void;
  isActiveFeatureFlag: (flagName: string) => boolean;
}

export const useFeatureFlags = (flags?: FeatureNames): IFeatureFlagsService => {
  const [featureFlags, setFeatureFlags] = useState<FeatureNames>(flags || []);

  const isActiveFeatureFlag = (flagName: string): boolean => !!featureFlags && featureFlags.includes(flagName);

  return {
    featureFlags,
    setFeatureFlags,
    isActiveFeatureFlag,
  };
};

export const FeatureFlagsContext = createContext<IFeatureFlagsService>({} as IFeatureFlagsService);

export const useFeatureFlagsService = (): IFeatureFlagsService => useContext(FeatureFlagsContext);
